/** Base interval + random jitter to spread client polls across time. */
export function pollIntervalMs(baseMs, jitterMaxMs = 60000) {
  if (jitterMaxMs <= 0) return baseMs;
  return baseMs + Math.floor(Math.random() * (jitterMaxMs + 1));
}
